import { motion } from 'motion/react';
import clsx from 'clsx';

interface ProgressBarProps {
  progress: number;
  status?: 'pending' | 'uploading' | 'completed' | 'error';
  size?: 'sm' | 'md';
  showLabel?: boolean;
}

export function ProgressBar({
  progress,
  status = 'uploading',
  size = 'md',
  showLabel = false,
}: ProgressBarProps) {
  const heights = {
    sm: 'h-1',
    md: 'h-2',
  };

  const colors = {
    pending: 'bg-gray-400',
    uploading: 'bg-primary-500',
    completed: 'bg-green-500',
    error: 'bg-red-500',
  };

  return (
    <div className="w-full">
      <div className={clsx('w-full bg-gray-200 dark:bg-slate-600 rounded-full overflow-hidden', heights[size])}>
        <motion.div
          className={clsx('h-full rounded-full', colors[status])}
          initial={{ width: 0 }}
          animate={{ width: `${Math.min(progress, 100)}%` }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        />
      </div>

      {showLabel && (
        <div className="flex justify-between mt-1">
          <span className="text-xs text-gray-500 dark:text-slate-400 capitalize">{status}</span>
          <span className="text-xs text-gray-500 dark:text-slate-400">{Math.round(progress)}%</span>
        </div>
      )}
    </div>
  );
}
